export default __webpack_public_path__ + "static/media/Q8_2_resized.aff3da2c.jpg";